<template>
<div class="powerTree">
    <el-tree :default-checked-keys="selectedAuth" :data="rootData" :expand-on-click-node="false" ref="tree"
             :check-on-click-node="true" node-key="id" :props="defaultProps" show-checkbox :default-expand-all="true">
        <span class="custom-tree-node" slot-scope="{node, data}"
              :class="[data.children &&data.type=='menu'&&data.children.length&& data.children[0].type=='button'?'cls1':'cls2']">
        <span>{{ node.label }}</span>
        </span>
    </el-tree>
</div>
</template>

<script>
import {getRoleView} from '@/api/subAccountApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'powerTree',
    data() {
        return {
            selectedAuth: [],
            rootData: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        }
    },
    props: ['isDisabled'],
    mounted() {
    },
    methods: {
        _getAuth() {
            let selectedNodes = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
            if (selectedNodes.length) {
                let auth = selectedNodes.join(',')
                return auth
            } else {
                this.$alert('请配置权限！', '提示', {
                    dangerouslyUseHTMLString: true
                })
            }
        },
        _cancal() {
            this.rootData = []
        },
        _getRoleView(roleid) {
            this.selectedAuth = []
            this.setLoading(true)
            getRoleView({
                data: {roleid: roleid},
                success: data => {
                    if (this.isDisabled) {
                        this.rootData = this._computeDisSelected(data.data.menu)
                    } else {
                        this.rootData = data.data.menu
                    }
                    let tmpList = this._computeSelected(this.rootData)
                    data.data.selnode.forEach(obj => {
                        if (obj.type === 'button') {
                            this.selectedAuth.push(obj.id)
                        } else {
                            tmpList.forEach(obj2 => {
                                if (obj.id === obj2) {
                                    this.selectedAuth.push(obj.id)
                                }
                            })
                        }
                    })
                    this.$nextTick(() => {
                        $('.cls1').parent().parent().each((index, element) => {
                            // $(element).children().last().css({display: 'flex'})
                            $(element).find('.el-tree-node__children').css({display: 'flex'})
                        })
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 禁用选择框
        _computeDisSelected(data) {
            compute(data)
            function compute(data) {
                data.forEach(obj => {
                    obj.disabled = true
                    if (obj.children && obj.children.length) {
                        compute(obj.children)
                    }
                })
            }
            return data
        },
        // 计算menu下没有button的menu
        _computeSelected(data) {
            let tmp = []
            compute(data)
            function compute(data) {
                data.forEach(obj => {
                    if (obj.type === 'menu' && (!obj.children || !obj.children.length)) {
                        tmp.push(obj.id)
                    } else if (obj.type === 'menu' && obj.children.length) {
                        compute(obj.children)
                    }
                })
            }
            return tmp
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.powerTree {
}
</style>
